const routes = [
    {
        path: 'agendamentos',
        name: 'listarAgendamento',
        alias: 'agendamentos/index',
        component: () => import('../views/Listar.vue')
    },
    {
        path: 'agendamentos/index/:id',
        name: 'listarAgendamentoId',
        redirect: to => ({
            path: 'agendamentos',
            query: { id: to.params.id }
        })
    },
    {
        path: 'agendamentos/editar/:id',
        component: () => import('../views/Editar.vue')
    },
    {
        path: 'agendamentos/visualizar/:id',
        component: () => import('../views/Visualizar.vue')
    },
    {
        path: 'agendamentos/sincronizar_google_agenda',
        name: 'sincronizarGoogleAgenda',
        component: () => import('../views/SincronizarGoogleAgenda.vue')
    }
]

export default routes
